import type { ChargerRepository } from '@/core/charger'
import type { UseCase } from '@/core/shared'

export const getChargerTypes: UseCase<ChargerRepository, 'getChargerTypes'> = repository => {
  return async () => {
    return await repository.getChargerTypes()
  }
}
